export enum WeaponGrip {
    LeftHandGrip = 'left_grip_bone',
    RightHandGrip = 'right_grip_bone',
}